import AbstractRsvpDetailsPageController from './abstract-details-controller';

export default class RsvpDetailsChangelogPageController extends AbstractRsvpDetailsPageController {

}



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/pages/rsvps/details/changelog-controller.js